import { COLORS } from "../../../../styles/variables"

export const TypTitle = {
    fontSize: "18px",
    minWidth: 0,
}

export const TypDescription = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    fontWeight: 300,
    color: COLORS.SMOKEY_GREY,
}

export const CardMediaStyle = {
    maxHeight: '500px',
    height: '100%',
    width: "calc(100% + 24px)",
    mx: "-12px",
    objectFit: "cover",
}

export const TypCharacteristics = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflowWrap: 'anywhere', 
    fontSize: '15px',

    '& span': {
        fontWeight: 400,
        paddingRight: '10px',
    },
}

export const BtnStyle = {
    padding: "6px 12px",
    minHeight: "32px",
    '@media (max-width:400px)': {
        padding: "6px 10px",
    },
}
